// Actions
export const setGraficos = ({ commit }, payload) => {
  commit('SET_GRAFICOS', payload)
}
export const addGraficos = ({ commit }, payload) => {
  commit('ADD_GRAFICOS', payload)
}
export const setGraficosLoading = ({ commit }, payload) => {
  commit('SET_GRAFICOS_LOADING', payload)
}

